import React, { useEffect, useState, useMemo } from 'react';
import InputMask from "react-input-mask";
import Functions from './Functions'
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import Api from '../services/Api'
import camera from '../assets/icons/camera.svg';
import { formatDocument, formatPhone } from '../config/countries';
import { useCountry } from '../contexts/CountryContext';

const ListItemUser = (props) => {
  const { t } = useTranslation();
  const { countryConfig } = useCountry();
  const [toggleItem, setToggleItem] = useState([]);
  
  const [formState, setFormState] = useState({
    _id: props._id,
    name: props.name,
    birthDate: props.birthDate,
    thumbnail: props.thumbnail,
    phone: props.phone,
    cpf: props.cpf,
    email: props.email,
    address: props.address,
    adminBusiness: props.adminBusiness,
    active: props.active
  });

  function onChangeThumbnailFile(e){
    if(e.target.files[0]){
      let file_size = e.target.files[0].size;
      if(parseInt(file_size) >= 5240000) {
        toast.error(t('common.form.imageError'), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }else{
        setStateThumbnail(e.target.files[0])
      }
    }
  };

  async function handleSubmit(e){
    e.preventDefault();
    if(formState.name !== ""){
      props.setLoading(true);
      var fileThumbnail = formState.thumbnail;
      const data = new FormData();
      data.append('id', props._id);
      data.append('name', formState.name);
      data.append('phone', formState.phone);
      data.append('cpf', formState.cpf);
      data.append('email', formState.email);
      if(props.view === "DashboardUser"){
        data.append('business', props.business._id);
        data.append('adminBusiness', formState.adminBusiness);
      }
      try {
        const response = await Api.post("/update-user", data);
        console.log(response);
        if(response.hasOwnProperty('_id') || response.hasOwnProperty('ok')){
          toast.success(t('dashboardUsers.notifications.success'), {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          if(props.view === "editUser"){
            props.setEditUser(false);
          } else {
            setToggleItem([]);
          }
          const reloadItem = props.loadItem;
          reloadItem();
          props.setLoading(false);
        } else {
          toast.error(t('dashboardUsers.notifications.error'), {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          props.setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      toast.error(t('common.form.requiredFields'), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }
  
  return (
      <li className={"itemDashboardList dashboardEditUser"} style={{listStyle: 'none'}}>
        {props.view === "DashboardUser" ?
          <div className="row v-center headList" onClick={() => {toggleItem[0] !== props._id ? setToggleItem([props._id]) : setToggleItem([])}}>
            <div className="col-10">
              <span>{formState.name}</span>
            </div>
            <div className="col-2 text-right">
              <span className={`iconItem ${toggleItem[0] === props._id ? 'fas fa-angle-up fa-lg ' : 'fas fa-angle-down fa-lg '}`}></span>
            </div>
          </div>
        : <></>}
        {props.view !== "DashboardUser" || toggleItem[0] === props._id ?
          <>
            <hr/>
            <form onSubmit={handleSubmit}>
              <div className="row v-center">
                <div className="col-12">
                  <div className="row v-center">
                    <div className="form-group col-md-6 col-12">
                      <label className="labelInput">{t('common.form.name')}</label>
                      <input
                        required 
                        type="text" 
                        className="form-control" 
                        placeholder={t('common.form.namePlaceholder')}
                        value={formState.name}
                        onChange={event => setFormState({...formState, name: event.target.value}) }
                      />
                    </div>
                    <div className="form-group col-md-6 col-12">
                      <label className="labelInput">{t('common.form.email')}</label>
                      <input
                        required 
                        disabled={props.view === "editUser" || props._id.toString().match(/^[0-9a-fA-F]{24}$/) ? "disabled" : ""} 
                        type="text" 
                        className="form-control" 
                        placeholder={t('common.form.emailPlaceholder')}
                        value={formState.email}
                        onChange={event => setFormState({...formState, email: event.target.value}) }
                      />
                    </div>
                    <div className="form-group col-md-6 col-6">
                      <label className="labelInput">{countryConfig.documents.individual.name}</label>
                      <InputMask
                        mask={countryConfig.documents.individual.mask}
                        type="text" 
                        className="form-control" 
                        placeholder={t('common.form.cpfPlaceholder')}
                        value={formState.cpf}
                        onChange={event => setFormState({...formState, cpf: event.target.value})}
                      />
                    </div>
                    <div className="form-group col-md-6 col-6">
                      <label className="labelInput">{t('common.form.phone')}</label>
                      <InputMask 
                        mask={countryConfig.phone.mask}
                        className="form-control" 
                        placeholder={t('common.form.phonePlaceholder')}
                        value={formState.phone}
                        onChange={event => setFormState({...formState, phone: event.target.value})}
                      />
                    </div>
                    {props.view === "DashboardUser" ? 
                      <div className="form-group col-12">
                        <label className="labelInput">{t('common.form.adminUser')}</label>
                        <select className="form-control" value={formState.adminBusiness} onChange={event => setFormState({...formState, adminBusiness: event.target.value })} >
                          <option value={false}>{t('common.form.adminUserNo')}</option>
                          <option value={true}>{t('common.form.adminUserYes')}</option>
                        </select>
                        {!props._id.toString().match(/^[0-9a-fA-F]{24}$/) ?
                          <span style={{fontSize: 14, color: "var(--colorText)"}}>{t('common.form.adminUserPasswordNote')}</span> 
                        : <></>}
                      </div>
                    : <></> }
                  </div>     
                </div>     
                <div className="col-12 text-right">
                  {props.view === "editUser" ?  
                    <div className="col-12 text-right">
                      <hr />
                      <button type="button" className="btn btn-delete" onClick={() => props.setEditUser(false)}>{t('common.form.close')}</button>
                        <span>&nbsp;&nbsp;&nbsp;</span>
                      <button type="submit" className="btn btn-default">{t('common.form.saveChanges')}</button>
                      <br />
                      <br />
                    </div>
                  :  
                    <div className="col-12 text-right">
                      {props.user !== props._id ? 
                        <button type="button" className="btn btn-delete" onClick={props.onDelete}>{t('common.form.delete')}</button>
                      : <></> }
                      <span>&nbsp;&nbsp;&nbsp;</span>
                      <button type="submit" className="btn btn-default">{t('common.form.save')}</button>
                    </div>
                  }
                </div>
              </div>
            </form>
          </>
        : '' }
      </li>
  );
};

export default ListItemUser;
